import { fadeInWithDelay } from "../../../js/animations/animations.js";
import { isMobile, isAuthor } from "../../../js/utils";

(() => {
  const brhGalleryTabs = {
    callback: function (el) {
      let count = 0;
      el.querySelectorAll(".brh-gallery__tabs-item").forEach((item) => {
        this.setLength(item);
        count += 0.2;
        if (!isMobile() && !isAuthor()) {
          fadeInWithDelay({ classElement: item, duration: 0.5, delay: count });
        }
        item.addEventListener("click", () => this.gotoAnchor(item.getAttribute("id")));
      });
    },

    gotoAnchor: function (anchorID) {
      const element = document.querySelector(`[data-anchor="${anchorID}"]`);
      if (element) {
        element.scrollIntoView();
      }
    },

    setLength: function (item) {
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.addedNodes.length > 0) {
            const anchorID = item.getAttribute("id");
            const anchor = document.querySelector(`[data-anchor="${anchorID}"]`);
            if (anchor) {
              setTimeout(() => {
                const numberItems = [...anchor.querySelector(".brh-gallery__swiper .swiper-wrapper").children].length;
                item.querySelector(".brh-gallery__tabs-item__number").innerHTML = numberItems;
              }, 500);
            }
            observer.disconnect();
          }
        });
      });
      observer.observe(document.querySelector(".brh-gallery__swiper .swiper-wrapper"), { childList: true });
    },
  };

  const BRHGalleryTabs = () => {
    const selectors = {
      component: ".brh-gallery-tabs",
    };

    const init = () => {
      const parentElement = Array.from(document.querySelectorAll(selectors.component));
      if (parentElement) {
        parentElement.forEach((element) => {
          brhGalleryTabs.callback(element);
        });
      }
    };
    init();
  };
  document.addEventListener("DOMContentLoaded", BRHGalleryTabs);
})();
